import React from 'react'
import { Redirect } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setAuthInfo } from '../../redux/actions/authActions'


const withAuth = (ComponentToProtect) => {
    return function (props) {
        const dispatch = useDispatch()

        const authInfo = JSON.parse(localStorage.getItem('authInfo'))
        dispatch(setAuthInfo(authInfo))

        if (authInfo) {
            return (
                <React.Fragment>
                    <ComponentToProtect {...props} authInfo={authInfo} />
                </React.Fragment>
            )
        }

        return <Redirect to="/login" />;
    }
}

export default withAuth